import { NON_VIEWED_COUPONS_COUNT } from '../actionTypes';

export const fetchNonViewedCouponsCount = coupons => ({
  type: NON_VIEWED_COUPONS_COUNT,
  payload: coupons,
});
